import styled from 'styled-components';
import { defaultColors } from '../../../styles/style-guide';

export const StepperItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StepNumber = styled.span<{
  $active: boolean;
  $activeColor: string;
  $inactiveBgColor: string;
  $inactiveTextColor: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${({ $active, $activeColor, $inactiveBgColor }) => ($active ? $activeColor : $inactiveBgColor)};
  color: ${({ $active, $inactiveTextColor }) => ($active ? defaultColors.white : $inactiveTextColor)};
`;

export const StepText = styled.span<{ $textColor?: string }>`
  color: ${({ $textColor }) => $textColor || defaultColors.primary};
  font-weight: 500;
`;
